<script>
    import {flip} from 'svelte/animate';
    import R, {LOADER} from "../../lib/requests";
    import Alert from "../../stores/alerts";
    import Notifier from "../../stores/notifier";
    import PageHeader from "../../components/PageHeader.svelte";
    import PageEdit from "./PageEdit.svelte";
    import AppIcon from "../../components/icons/AppIcon.svelte";

    const pageHeaderControls = [
        {id: 'create', name: 'ΠΡΟΣΘΗΚΗ ΣΕΛΙΔΑΣ', class: 'hidden-xs'},
        {
            id: 'create',
            name: '',
            icon: 'plus-circle',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    let pages = null;
    let pageId = null;
    let hovering = false;

    const load = () => {
        const onSuccess = result => {
            pages = result;
        }

        const onFailure = err => {
        };


        R.handle(R.page.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const saveOrder = () => {
        const onSuccess = result => {
            Notifier.showMessage("Η σειρά εμφάνισης ενημερώθηκε");
        }

        const onFailure = err => {
        };


        let data = pages.map(item => (item.id));

        R.handle(R.page.order, data, onSuccess, onFailure, LOADER.NONE);
    }

    const onCreate = () => {
        if (pageId == null) {
            pageId = 0;
        }
    }

    const onEdit = (page) => {
        if (pageId != null && pageId != page.id) {
            Alert.warning("Σελίδα", "Κλείστε την σελίδα προς επεξεργασία για να επιλέξετε άλλη σελίδα!");
            return;
        }
        pageId = page.id;
    }

    const onClose = param => {
        if (param) {
            let page = pages.find(x => x.id == param.id);
            if (page) {
                page.name = param.name;
                page.code = param.code;
                pages = pages;
            } else {
                pages = [...pages, {
                    id: param.id,
                    name: param.name,
                    code: param.code,
                }];
            }
        }
        pageId = null;
    }

    const onDelete = (page) => {
        Alert.delete("Διαγραφή σελίδας", `Πρόκειται να διαγράψετε την σελίδα "${page.name}".\nΘέλετε να συνεχίσετε;`, () => deletePage(page.id));
    }

    const deletePage = id => {
        const onSuccess = result => {
            pages = pages.filter(x => x.id != result);
            pageId = null;
            Notifier.showMessage("Η σελίδα διαγράφτηκε");
        }

        const onFailure = err => {
        };

        R.handle(R.page.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const dragstart = (event, i) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.setData('text/plain', i);
    }

    const drop = (event, target) => {
        event.dataTransfer.dropEffect = 'move';
        const start = parseInt(event.dataTransfer.getData("text/plain"));
        const newTracklist = pages;

        if (start < target) {
            newTracklist.splice(target + 1, 0, newTracklist[start]);
            newTracklist.splice(start, 1);
        } else {
            newTracklist.splice(target, 0, newTracklist[start]);
            newTracklist.splice(start + 1, 1);
        }
        pages = newTracklist;
        hovering = null;
        saveOrder();
    }

    load();
</script>

<PageHeader title="Σελίδες" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>
<div class="row">
    <div class="col-xl-4">

        {#if pages}
            {#if pages.length}
                <table class="table table-list table-list-border">
                    <tbody>
                    {#each pages as item, index (item.id)}
                        <tr class="row-hover row-item" class:row-selected="{ pageId === item.id }"
                            animate:flip="{{ duration: 100 }}"
                            draggable={true}
                            on:dragstart={event => dragstart(event, index)}
                            on:drop|preventDefault={event => drop(event, index)}
                            ondragover="return false"
                            on:dragenter={() => hovering = index}
                            class:drag-over={hovering === index}>
                            <td>
                                <div class="is-link" on:click={ () => onEdit(item) }>{ item.name }</div>
                            </td>
                            <td class="text-gray">{ item.code }</td>
                            <td class="button-column pointer" title="διαγραφή σελίδας"
                                on:click="{ () => onDelete(item) }">
                                <AppIcon icon="trash" size="16"/>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {:else}
                <div class="panel panel-simple panel-pad">
                    Δεν υπάρχουν σελίδες!
                </div>
            {/if}
        {/if}
    </div>
    <div class="col-xl-8">
        {#if pageId != null}
            <PageEdit {pageId} onCloseHandler="{ onClose }"/>
        {/if}
    </div>
</div>